//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableEmployees from './../Employee/TableEmployees.vue'
import { formatEmployeeName } from './OrderAdmittanceFunctions.js'

export default {
  components: {
    TableEmployees: TableEmployees
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      selectedEmployee: null,
      employeeTable: '',
      formatEmployeeName: formatEmployeeName,
      modalOpened: false
    }
  },
  computed: {
    readonly: function () {
      return this.orderAdmittance.state !== 'AD0' && this.orderAdmittance.state !== 'AD1' && this.orderAdmittance.state !== 'AD2'
    }
  },
  methods: {
    onShowSeniorTable: function () {
      if (this.readonly) {
        return
      }
      this.employeeTable = 'seniorTable'
      this.selectedEmployee = this.orderAdmittance.seniorEmployee
      this.modalOpened = true
    },
    saveSenior: function (employee) {
      if (!this.orderAdmittance.seniorEmployee) {
        this.orderAdmittance.seniorEmployee = {}
      }
      this.orderAdmittance.seniorEmployee.fio = employee.shortName
      this.orderAdmittance.seniorEmployee.key = employee.key
      this.orderAdmittance.seniorEmployee.position = employee.positionName
      this.closeModal()
    },
    onShowAdmittingEmployeeTable: function () {
      if (this.readonly) {
        return
      }
      this.employeeTable = 'admittingEmployeeTable'
      this.selectedEmployee = this.orderAdmittance.admittingEmployee
      this.modalOpened = true
    },
    saveAdmittingEmployee: function (employee) {
      if (!this.orderAdmittance.admittingEmployee) {
        this.orderAdmittance.admittingEmployee = {}
      }
      this.orderAdmittance.admittingEmployee.fio = employee.shortName
      this.orderAdmittance.admittingEmployee.key = employee.key
      this.orderAdmittance.admittingEmployee.position = employee.positionName
      this.closeModal()
    },
    closeModal: function () {
      this.modalOpened = false
      this.selectedEmployee = null
    }
  }
}

